import { UsergroupAddOutlined } from "@ant-design/icons";
import "./index.css";
import { HiMiniHeart } from "react-icons/hi2";

const HeaderData = [
  {
    key: "time",
    title: (
      <h1
        style={{
          fontFamily: "Poppins",
          fontWeight: 400,
        }}
      >
        Time of Activity
      </h1>
    ),
    dataIndex: "time",
    sorter: (a, b) => a.time.length - b.time.length,
    // sortDirections: ["descend"],
  },
  {
    key: "activity",
    title: (
      <h1
        style={{
          fontFamily: "Poppins",
          fontWeight: 400,
        }}
      >
        Activity
      </h1>
    ),
    dataIndex: "activity",
  },
  {
    key: "transactionDetails",
    title: (
      <h1
        style={{
          fontFamily: "Poppins",
          fontWeight: 400,
        }}
      >
        Transaction Details
      </h1>
    ),
    dataIndex: "transactionDetails",
  },
  {
    key: "performedBy",
    title: (
      <h1
        style={{
          fontFamily: "Poppins",
          fontWeight: 400,
        }}
      >
        Performed By
      </h1>
    ),
    dataIndex: "performedBy",
  },
];

const usersHeaderData = [
  {
    key: "name",
    title: (
      <h1
        style={{
          fontFamily: "Poppins",
        }}
      >
        Name
      </h1>
    ),
    dataIndex: "name",
    // sortDirections: ["descend"],
  },
  {
    key: "roleName",
    title: (
      <h1
        style={{
          fontFamily: "Poppins",
        }}
      >
        Role Name
      </h1>
    ),
    dataIndex: "roleName",
    // sortDirections: ["descend"],
  },
  {
    key: "mobileNo",
    title: (
      <h1
        style={{
          fontFamily: "Poppins",
        }}
      >
        Mobile No
      </h1>
    ),
    dataIndex: "mobileNo",
  },
  {
    key: "userName",
    title: (
      <h1
        style={{
          fontFamily: "Poppins",
        }}
      >
        User Name
      </h1>
    ),
    dataIndex: "userName",
    sorter: (a, b) => a.userName.length - b.userName.length,
    // sortDirections: ["descend"],
  },
  {
    key: "password",
    title: (
      <h1
        style={{
          fontFamily: "Poppins",
        }}
      >
        Password
      </h1>
    ),
    dataIndex: "password",
  },
  {
    key: "action",
    title: (
      <h1
        style={{
          fontFamily: "Poppins",
        }}
      >
        Action
      </h1>
    ),
    dataIndex: "action",
  },
];

const TableData = [
  {
    timeActivity: "1",
    activity: "Created Purchase",
    transactionDetails: "777",
    performedBy: "Your Name",
  },
  {
    timeActivity: "2",
    activity: "Creates Sales",
    transactionDetails: "777",
    performedBy: "Admin",
  },
];
const usersCardList = [
  {
    label: "Number of Users",
    key: 1,
    icon: <UsergroupAddOutlined />,
    parties: "1",
    color: "#059f74",
    days: "",
  },
  {
    label: "Activities Performed",
    key: 2,
    icon: <HiMiniHeart size={16} />,
    amount: "0",
    color: "#0b7ed2",
    days: "Last 30 Days",
  },
];
const items = [
  {
    label: "All Transactions",
    value: "All Transactions",
  },
  {
    label: "Old Transactions",
    value: "Old Transactions",
  },
  {
    label: "Edit Transations",
    value: "Edit Transations",
  },
  {
    label: "Delete Transactions",
    value: "Delete Transactions",
  },
];

const faqMenus = [
  {
    label: "Invoices",
    value: "Invoices",
  },
  {
    label: "Shortcuts",
    value: "Shortcuts",
  },
];
const industryTypeOptions = [
  {
    label: "Information Technology",
    value: "Information Technology",
  },
  {
    label: "Accounts",
    value: "Accounts",
  },
  {
    label: "Agriculture",
    value: "Agriculture",
  },
  {
    label: "Automobile",
    value: "Automobile",
  },
  {
    label: "Electronics",
    value: "Electronics",
  },
  {
    label: "Networking",
    value: "Networking",
  },
  {
    label: "Doctor",
    value: "Doctor",
  },
  {
    label: "Enginerring",
    value: "Enginerring",
  },
];
const businessTypeOptions = [
  {
    label: "Retailer",
    value: "Retailer",
  },
  {
    label: "Wholesales",
    value: "Wholesales",
  },
  {
    label: "Distributor",
    value: "Distributor",
  },
  {
    label: "Manufaturer",
    value: "Manufaturer",
  },
  {
    label: "Services",
    value: "Services",
  },
];
const invoiceTypeList = [
  {
    label: "Can I add custom fields to Invoices?",
    text: "Yes! We understand that every business has their own personal invoicing requirements and to fulfill this, we’ve given the feature to add any custom field to your invoice such as Delivery Date, Transport, Drug License Number etc",
    subText:
      "Click on the Invoice Settings button at the top of the Sales Screen to add custom fields to your invoices.",
    value: "1",
    type: "Invoices",
  },
  {
    label: "Can I add custom fields for items? Will they show on invoice?",
    text: "Yes! Custom item fields such as Batch No, Expiry Date, IMEI, Size etc can be added to items and invoices.",
    subText:
      "Click on Item Settings button at the top of the Inventory Screen to add custom fields to your items.To Show/Hide these custom fields in your invoices, click on the " +
      " button next to the Amount column of the items table in Create Invoice.",
    value: "2",
    type: "Invoices",
  },
  {
    label: "Services",
    text: "My BillBook supports A4, A5 & Thermal printing through USB(on desktop) & Bluetooth(on mobile).",
    subText: "",
    value: "3",
    type: "Invoices",
  },
];
const shortcutList = [
  {
    label: "Are there any Keyboard Shortcuts available?",
    text: "20+ keyboard shortcuts have been added to make your work on My BillBook faster. View the shortcuts list from any screen by pressing ‘ALT’ button on your keyboard.",
    value: "1",
    type: "Shortcuts",
  },
];

const businessRegisrationOptions = [
  {
    label: "Private Limited Company",
    value: "Private Limited Company",
  },
  {
    label: "Public Limited Company",
    value: "Public Limited Company",
  },
  {
    label: "Sole Proprietorship",
    value: "Sole Proprietorship",
  },
  {
    label: "Partnerships Firm",
    value: "Partnerships Firm",
  },
  {
    label: "Limited Liability Partnership",
    value: "Limited Liability Partnership",
  },
  {
    label: "One Person Company",
    value: "One Person Company",
  },
  {
    label: "Sole Proprietorship",
    value: "Sole Proprietorship",
  },
  {
    label: "Section 8 Company",
    value: "Section 8 Company",
  },
  {
    label: "Business Not Registered",
    value: "Business Not Registered",
  },
];

export {
  items,
  industryTypeOptions,
  businessTypeOptions,
  businessRegisrationOptions,
  usersCardList,
  TableData,
  faqMenus,
  shortcutList,
  invoiceTypeList,
  usersHeaderData,
  HeaderData,
};
